import "./qr_style.css"
import API_public from "../utils/API_public"
import React from "react"
import QrReader from "react-qr-reader";
import {AlertDialog, Button, Modal, ProgressBar, Input, Page, Card, Row, Icon} from 'react-onsenui';
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";

const SCAN_VALID = 'scan_valid'
const SCANNED_BEFORE = 'scanned_before'
const SCAN_INVALID = 'scan_invalid'

class QrScanner extends React.Component {
    state = {
        facingMode: "environment",
        monitoring: true,
        scans: [],
        loading: false,
        openResultDialog: false,
        dialogTitle: "Valid",
        dialogText: "The ticket is valid",
        dialogTextColor: "green",
        // manual code
        showManualInput: false,
        manualInput: "",
        deviceName: null,
        pendingDeviceName: null,
        editingDeviceName: false,
        showDeviceNameBlankError: false
    }

    componentDidMount() {
        const scannerDeviceName = localStorage.getItem("StarStreamScannerDeviceName")
        if (scannerDeviceName) {
            this.setState({
                editingDeviceName: false,
                pendingDeviceName: scannerDeviceName,
                deviceName: scannerDeviceName
            })
        } else {
            this.setState({
                editingDeviceName: true,
                pendingDeviceName: scannerDeviceName,
                deviceName: scannerDeviceName
            })
        }
    }

    handleScan = async (data) => {
        if (data) {
            if (this.state.monitoring) {
                this.setState({
                    monitoring: false,
                    loading: true,
                })

                // validate the ticket
                const result = await this.validateTicket(data)

                if (result.status === SCAN_VALID) {
                    this.setState({
                        dialogTitle: "Valid",
                        dialogText: result.message,
                        dialogTextColor: "green"
                    })
                    this.state.scans.push({
                        time: new Date(result.scan.created_at * 1000),
                        data: data,
                        status: result.status,
                        deviceName: result.scan.device_name,
                        prevScans: result.prev_scans,
                        color: 'green'
                    })

                } else if (result.status === SCANNED_BEFORE) {
                    this.setState({
                        dialogTitle: "Valid",
                        dialogText: result.message,
                        dialogTextColor: "orange"
                    })
                    this.state.scans.push({
                        time: new Date(result.scan.created_at * 1000),
                        data: data,
                        status: result.status,
                        deviceName: result.scan.device_name,
                        prevScans: result.prev_scans,
                        color: 'orange'
                    })

                } else {
                    this.setState({
                        dialogTitle: "Invalid",
                        dialogText: result.message,
                        dialogTextColor: "red"
                    })
                    this.state.scans.push({
                        time: new Date(),
                        data: data,
                        status: result.status,
                        deviceName: this.state.deviceName,
                        color: 'red'
                    })
                }

                this.setState({
                    loading: false,
                    openResultDialog: true
                })
            }
        }
    }

    validateTicket = async (qr_data) => {
        try {
            const response = await API_public.post(`/scans`, { qr_data, device_name: this.state.deviceName })
            return response.data
        } catch (e) {
            Sentry.withScope(scope => {
                scope.setExtra("handled", true)
                Sentry.captureException(e)
            })
            console.log(e)
            return {valid: false};
        }
    }

    handleError = err => {
        console.error(err)
    }

    closeDialog = () => {
        this.setState({
            openResultDialog: false,
            loading: false,
            monitoring: true,
        })
    }

    submitEnterCodeManually = async () => {
        this.setState({
            showManualInput: false,
        })
        await this.handleScan(this.state.manualInput)
    }

    render() {
        let rows = [];
        for (let i = this.state.scans.length - 1; i >= 0; i--) {
            const r_time = this.state.scans[i].time
            const r_data = this.state.scans[i].data
            const status = this.state.scans[i].status
            const valid_str = status === SCAN_INVALID ? "invalid" : "valid"
            const color = this.state.scans[i].color
            const deviceName = this.state.scans[i].deviceName

            rows.push(
                <tr key={`scan-row-${i}`}>
                    <td>
                        <div style={{color: color}}>
                            #{i + 1} - {r_data} - {valid_str} - {deviceName} @{r_time.toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                        })}
                        </div>
                    </td>
                </tr>
            );
        }

        if (this.state.scans.length <= 0) {
            rows.push(
                <tr key={`scan-row-${0}`}>
                    <td>
                        <div>
                            No Data
                        </div>
                    </td>
                </tr>
            );
        }

        return (
            <React.Fragment>
                {this.state.editingDeviceName ? (

                    <Page
                        contentStyle={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            padding: '0 8px 60px 8px'
                        }}
                    >
                        <h1 style={{textAlign: 'center'}}>Starstream Code Scanner</h1>
                        <Card style={{margin: '8px 0'}}>
                            <label style={{fontSize: '12px', fontWeight: '400'}}>Device name</label>
                            {this.state.pendingDeviceName === '' &&
                                <div style={{fontSize: '12px', fontWeight: '400', color: 'red'}}>can't be blank</div>
                            }
                            <Input
                                placeholder='Please give a name to this scanner'
                                style={{width: '100%'}}
                                value={this.state.pendingDeviceName}
                                onInput={(event) => {
                                    this.setState({pendingDeviceName: event.target.value})
                                }}
                            />
                        </Card>
                        <Row style={{paddingTop: '16px'}}>
                            <Button
                                modifier="large"
                                disabled={this.state.pendingDeviceName === ''}
                                onClick={() => {
                                    if (this.state.pendingDeviceName && this.state.pendingDeviceName.length > 0) {
                                        localStorage.setItem('StarStreamScannerDeviceName', this.state.pendingDeviceName)
                                        this.setState({
                                            deviceName: this.state.pendingDeviceName,
                                            editingDeviceName: false
                                        })
                                    } else {
                                        this.setState({
                                            pendingDeviceName: ''
                                        })
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Row>
                        {this.state.deviceName &&
                            <Row style={{paddingTop: '16px'}}>
                                <Button
                                    modifier="large outline"
                                    disabled={this.state.deviceName === ''}
                                    onClick={() => {
                                        this.setState({
                                            pendingDeviceName: this.state.deviceName,
                                            editingDeviceName: false
                                        })
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Row>
                        }
                    </Page>

                ) : (

                    <React.Fragment>
                        <div>
                            <div style={{padding: "10px", textAlign: "center", fontWeight: "bold", fontSize: "18px"}}>
                                Starstream QR Code Scanner
                            </div>
                        </div>
                        <div style={{color: "grey", textAlign: "center", padding: "0 10px 10px 10px", fontSize: "14px"}}>
                            <div style={{marginBottom: "4px"}}>
                                You can bookmark this webpage on your phone home-screen to access Starstream QR Code Scanner
                                quickly.
                            </div>
                            <div>
                                You can share this url with your employees, so they can scan tickets too.
                            </div>
                        </div>
                        <div>
                            <QrReader
                                delay={300}
                                onError={this.handleError}
                                onScan={this.handleScan}
                                style={{width: '100%'}}
                                facingMode={this.state.facingMode}
                                showViewFinder={true}
                            />
                        </div>
                        <div style={{display: "flex", alignItems: "center", justifyContent: 'center', margin: '0 20px'}}>
                            <h2 style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                                {this.state.deviceName}
                            </h2>
                            <Button
                                modifier="quiet"
                                onClick={() => this.setState({editingDeviceName: true})}
                            >
                                <Icon
                                    size={{material: 16}}
                                    icon={{material: 'edit'}}
                                    modifier="material"
                                />
                            </Button>
                        </div>
                        <div style={{padding: "0 10px 10px 10px"}}>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <Button onClick={
                                    () => {
                                        if (this.state.facingMode == "environment") {
                                            this.setState({facingMode: "user"})
                                        } else {
                                            this.setState({facingMode: "environment"})
                                        }
                                    }
                                }>
                                    Flip Camera
                                </Button>
                                <Button style={{marginLeft: "10px"}} onClick={
                                    () => {
                                        this.setState({showManualInput: true})
                                    }
                                }>
                                    Enter code manually
                                </Button>
                            </div>

                            <table style={{textAlign: "center", width: "100%", paddingTop: "10px"}}>
                                <thead>
                                <tr>
                                    <th>Scans</th>
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </table>

                            <div style={{display: "none", justifyContent: "center"}}>
                                <Button onClick={() => {
                                    this.handleScan("Example Data")
                                }}>
                                    Simulate
                                </Button>
                            </div>
                        </div>
                        <Modal isOpen={this.state.loading}>
                            Validating ticket with Starstream's servers...
                            <ProgressBar indeterminate/>
                        </Modal>
                        <AlertDialog isOpen={this.state.openResultDialog}
                                    onCancel={this.closeDialog}
                                    cancelable
                                    style={{color: this.state.dialogTextColor}}
                        >
                            <div
                                className="alert-dialog-title"
                                style={{color: this.state.dialogTextColor}}
                            >
                                {this.state.dialogTitle}
                            </div>
                            <div
                                className="alert-dialog-content"
                                style={{color: this.state.dialogTextColor}}
                            >
                                {this.state.dialogText}
                            </div>
                            <div
                                className="alert-dialog-footer"
                            >
                                <Button onClick={this.closeDialog} className="alert-dialog-button">
                                    Ok
                                </Button>
                            </div>
                        </AlertDialog>
                        <AlertDialog isOpen={this.state.showManualInput}>
                            <div
                                className="alert-dialog-title"
                            >
                                Enter ticket code manually
                            </div>
                            <div
                                className="alert-dialog-content"
                            >
                                The code is located under the QR Code. The format is XXX-YYY-ZZZZZZ.
                            </div>
                            <div
                                className="alert-dialog-content"
                            >
                                <Input
                                    value={this.state.manualInput} float
                                    onChange={(event) => {
                                        this.setState({manualInput: event.target.value})
                                    }}
                                    modifier='material'
                                    placeholder='Code'/>
                            </div>
                            <div
                                className="alert-dialog-footer"
                            >
                                <Button onClick={this.submitEnterCodeManually} className="alert-dialog-button">
                                    Enter
                                </Button>
                            </div>
                        </AlertDialog>
                    </React.Fragment>

                )}
            </React.Fragment>
        )
    }
}

QrScanner.propTypes = {
    onQrCode: PropTypes.func,
    monitorQrCode: PropTypes.bool,
}

QrScanner.defaultProps = {
    monitorQrCode: true,
    onQrCode: (data) => {
    },
}

export default QrScanner